import AdminService from '../../services/admin.service'

const state = {
    namespaced: true,
    panels: []
}
const mutations = {
    addPanels(state, panels){
        state.panels = panels
    }
}

const actions = {
    getAdminBoard ({ commit }, reqToken) {
        return AdminService.getAdminBoard(reqToken).then(
            panels => {
            commit('addPanels', panels.token)
            return Promise.resolve(panels)
        })
    },

    activateUser ({ commit }, email) {
        return AdminService.activateUser(email)
    },

    deactivateUser ({ commit }, email) {
        return AdminService.deactivateUser(email)
    },

    updateSubscription ({ commit }, payload) {
        return AdminService.updateSubscription(payload.email, payload.abonnement)
    },

    isAdmin ({ commit }, reqToken) {
        return AdminService.isAdmin(reqToken)
    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
  }  